import { Outlet, useOutletContext } from 'react-router-dom'

import { Alert, Box, Icon, Text } from '@factorialco/deprecated-design-system'
import { AtsJobApplicationMessagesPageFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import { MessageBoard } from 'modules/ats/components/MessageBoard'
import { useMarkAsReadConversation } from 'modules/ats/hooks/conversations/useMarkAsReadConversation'

interface OutletContext {
  application: AtsJobApplicationMessagesPageFragment
  isReviewerRole: boolean
}

const JobApplicationDetailMessagesPage = () => {
  const { application, isReviewerRole } = useOutletContext<OutletContext>()
  const { access, company } = useCurrentSession()
  const hasEmail = !!application.candidate.email
  const { markAsReadConversation } = useMarkAsReadConversation()

  useEffect(() => {
    if (!application.conversation?.id || isReviewerRole) return

    markAsReadConversation({
      id: Number(application.conversation.id),
      accessId: access.id,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [application.id])

  if (isReviewerRole) {
    return null
  }

  return (
    <>
      <Box gap="s24" padding="s24" flexGrow>
        {!hasEmail && (
          <Alert color="warning">
            <Box alignItems="flexStart" flexDirection="row" gap="s4">
              <Box flexNoShrink>
                <Icon.Medium icon="alert-circle" color="grey800" />
              </Box>
              <Text.Normal>{i18n.t('ats.candidates.messages.candidate_has_no_email')}</Text.Normal>
            </Box>
          </Alert>
        )}

        <MessageBoard application={application} companyId={company.id} />
      </Box>
      <Outlet context={{ application }} />
    </>
  )
}

export default JobApplicationDetailMessagesPage
